/// <reference types="node" />
import { ParsedUrlQuery } from 'querystring';

export const cartIdQuery = 'cart';

export const getCartIdFromQuery = (query: ParsedUrlQuery): string | null => {
  return <string>query[cartIdQuery] || null;
};
